import Broker_Minimal from './Broker_Minimal'

export default {
    Broker_Minimal,
}
